var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-comment" },
    [
      !_vm.hidden
        ? _c("div", { staticClass: "emap-flow-comment-opt" }, [
            _vm.label
              ? _c(
                  "div",
                  {
                    staticClass: "comment-title",
                    class: {
                      "comment-required":
                        _vm.required || _vm.needElecseal || _vm.needEsignature,
                    },
                  },
                  [_vm._v(_vm._s(_vm.label))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.schema != "default" ||
            (_vm.showCurComment && _vm.taskId && !_vm.isFinishedTask)
              ? _c(
                  "div",
                  {
                    staticClass: "emap-flow-comment-item current-comment",
                    class: [
                      {
                        hasElecseal: _vm.elecseal || _vm.esignature,
                        radio:
                          (_vm.elecseal || _vm.esignature) && !_vm.multiple,
                      },
                    ],
                  },
                  [
                    _vm.checkboxOnly &&
                    _vm.mergeOptions.length === 1 &&
                    _vm.showInput
                      ? [
                          _c(
                            "Checkbox",
                            {
                              attrs: {
                                "true-value": _vm.mergeOptions[0].id,
                                "false-value": "",
                                disabled: _vm.mergeOptions[0].disabled,
                              },
                              on: { "on-change": _vm.approvalChange },
                              model: {
                                value: _vm.approval,
                                callback: function ($$v) {
                                  _vm.approval = $$v
                                },
                                expression: "approval",
                              },
                            },
                            [
                              _c("span", { staticClass: "option-label" }, [
                                _vm._v(_vm._s(_vm.mergeOptions[0].name)),
                              ]),
                            ]
                          ),
                        ]
                      : [
                          _vm.showInput
                            ? _c(
                                "RadioGroup",
                                {
                                  staticStyle: { display: "block" },
                                  on: { "on-change": _vm.approvalChange },
                                  model: {
                                    value: _vm.approval,
                                    callback: function ($$v) {
                                      _vm.approval = $$v
                                    },
                                    expression: "approval",
                                  },
                                },
                                _vm._l(_vm.mergeOptions, function (item) {
                                  return _c(
                                    "Radio",
                                    {
                                      key: item.id,
                                      attrs: {
                                        label: item.id,
                                        disabled: item.disabled,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "option-label" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "ivu-form-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "ivu-form-item-content",
                          staticStyle: { display: "flex" },
                        },
                        [
                          _c(
                            "Dropdown",
                            {
                              staticClass: "dropdown-input",
                              attrs: {
                                trigger: "click",
                                transfer: "",
                                placement: "bottom-start",
                              },
                              on: { "on-click": _vm.chooseComment },
                            },
                            [
                              _vm.showInput
                                ? _c(
                                    "Input",
                                    {
                                      staticClass: "comment-simulator",
                                      class: [
                                        {
                                          "comment-input-error":
                                            _vm.validateError,
                                          "comment-input-readonly":
                                            _vm.readonly,
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "comment-wrapper",
                                          attrs: { slot: "append" },
                                          slot: "append",
                                        },
                                        [
                                          _c("Input", {
                                            staticClass: "comment-textarea",
                                            attrs: {
                                              type: "textarea",
                                              placeholder: _vm.il8Placeholder,
                                              autosize: true,
                                              readonly: _vm.readonly,
                                            },
                                            on: {
                                              "on-blur": _vm.onBlur,
                                              "on-focus": _vm.onFocus,
                                            },
                                            model: {
                                              value: _vm.comment,
                                              callback: function ($$v) {
                                                _vm.comment =
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                              },
                                              expression: "comment",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "comment-toolbar" },
                                            [
                                              _vm.sample && !_vm.readonly
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "comment-sample-save",
                                                      class: {
                                                        disabled: !_vm.comment,
                                                      },
                                                      on: {
                                                        click: _vm.saveSample,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$LocalH5(
                                                            "saveComment"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showInput
                                ? _c(
                                    "dropdown-menu",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.showSample &&
                                            _vm.defaultComments.length,
                                          expression:
                                            "showSample && defaultComments.length",
                                        },
                                      ],
                                      attrs: { slot: "list" },
                                      slot: "list",
                                    },
                                    [
                                      _c(
                                        "dropdown-item",
                                        { attrs: { disabled: "" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$LocalH5("commonComment")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.defaultComments,
                                        function (item, index) {
                                          return _c(
                                            "dropdown-item",
                                            {
                                              key: index,
                                              attrs: {
                                                divided: !index,
                                                name: item.NAME,
                                              },
                                            },
                                            [_vm._v(" " + _vm._s(item.NAME))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.getSealLoading
                            ? [
                                (_vm.elecseal || _vm.esignature) &&
                                _vm.signatureType == "3" &&
                                _vm.hasLoaded &&
                                _vm.schema === "default"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "emap-flow-comment-elecseal e-signature-wrap",
                                        },
                                        [
                                          _c(
                                            "e-seal",
                                            _vm._b(
                                              { ref: "eSeal" },
                                              "e-seal",
                                              {
                                                elecseal: _vm.elecseal,
                                                esignature: _vm.esignature,
                                              },
                                              false
                                            )
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                (_vm.elecseal || _vm.esignature) &&
                                _vm.signatureType == "4"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "emap-flow-comment-elecseal e-signature-wrap",
                                        },
                                        [
                                          _c("nuo-seal", {
                                            ref: "nuoSealComp",
                                            attrs: {
                                              sealConfigData:
                                                _vm.sealConfigData,
                                              "nuo-seal": _vm.nuoSeal,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _vm.signatureType == "1"
                                        ? [
                                            _vm.elecseal || _vm.esignature
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "emap-flow-comment-elecseal",
                                                    class: _vm.elecsealClassArr,
                                                    attrs: { id: "pos" },
                                                    on: {
                                                      click: _vm.sealSelect,
                                                    },
                                                  },
                                                  [
                                                    (
                                                      _vm.multiple
                                                        ? _vm.chapterUrl
                                                            .length < 2
                                                        : !_vm.chapterUrl.length
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "emap-flow-elecseal-label",
                                                            class: [
                                                              {
                                                                single:
                                                                  _vm.multiple &&
                                                                  _vm.chapterUrl
                                                                    .length ==
                                                                    1,
                                                                radio:
                                                                  !_vm.multiple,
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.elecseal
                                                                    ? _vm.$LocalH5(
                                                                        "sealOrSign.addSeal"
                                                                      )
                                                                    : _vm.$LocalH5(
                                                                        "sealOrSign.addSignature"
                                                                      )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.chapterUrl.length
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "emap-flow-elecseal-imgs",
                                                          },
                                                          _vm._l(
                                                            _vm.chapterUrl,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "emap-flow-elecseal-img",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: item,
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  !_vm.readonly
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "img-popup-body",
                                                                          on: {
                                                                            click:
                                                                              _vm.preventEvent,
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "Button",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  type: "text",
                                                                                  ghost:
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  _vm.modifySeal,
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$LocalH5(
                                                                                    "change"
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "Button",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  type: "text",
                                                                                  ghost:
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.delSeal(
                                                                                      item,
                                                                                      index
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$LocalH5(
                                                                                    "delete"
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm.signatureType == "2"
                                        ? [
                                            _vm.elecseal || _vm.esignature
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "emap-flow-comment-elecseal",
                                                    class: _vm.elecsealClassArr,
                                                    attrs: { id: "pos" },
                                                  },
                                                  [
                                                    _vm.multiple
                                                      ? [
                                                          _vm.kingGridWidArr
                                                            .length < 2
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "emap-flow-elecseal-label",
                                                                  class: [
                                                                    {
                                                                      single:
                                                                        (_vm
                                                                          .kingGridWidArr
                                                                          .length ==
                                                                          1 &&
                                                                          _vm.curOptPos ===
                                                                            _vm
                                                                              .kingGridPosArr[1]) ||
                                                                        (_vm
                                                                          .kingGridWidArr
                                                                          .length ==
                                                                          1 &&
                                                                          !_vm.curOptPos),
                                                                      "single-left":
                                                                        _vm
                                                                          .kingGridWidArr
                                                                          .length ==
                                                                          1 &&
                                                                        _vm.curOptPos ===
                                                                          _vm
                                                                            .kingGridPosArr[0],
                                                                    },
                                                                  ],
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$LocalH5(
                                                                        "sealOrSign.addSeal"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      : [
                                                          _vm.kingGridWidArr
                                                            .length < 1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "emap-flow-elecseal-label radio",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$LocalH5(
                                                                        "sealOrSign.addSeal"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.kingGridPosArr,
                                                      function (item, index) {
                                                        var _obj
                                                        return _c("div", {
                                                          key: index,
                                                          class:
                                                            ((_obj = {}),
                                                            (_obj[
                                                              "king-grid-pos-" +
                                                                (index + 1)
                                                            ] = true),
                                                            (_obj["radio"] =
                                                              !_vm.multiple),
                                                            _obj),
                                                          attrs: { id: item },
                                                          on: {
                                                            click:
                                                              _vm.sealSelect,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.schema === "default" && _vm.showOldComment && _vm.taskId
        ? _c("div", { staticClass: "emap-flow-old-comment" }, [
            _c(
              "div",
              {
                staticClass: "history-comment-label",
                on: { click: _vm.handleHistory },
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$LocalH5("sealOrSign.viewOther"))),
                ]),
                _c("Icon", {
                  staticClass: "history-icon",
                  attrs: {
                    type: _vm.showHistory ? "ios-arrow-up" : "ios-arrow-down",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showHistory,
                    expression: "showHistory",
                  },
                ],
                staticClass: "history-comment-content",
              },
              [
                _c(
                  "div",
                  { staticClass: "history-comment-empty" },
                  [
                    _vm.historyLoading
                      ? _c("Spin", {
                          staticClass: "history-comment-loading",
                          attrs: { size: "large" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.historyEmpty
                      ? _c("span", [_vm._v(_vm._s(_vm.$LocalH5("noData")))])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.flowComments, function (item, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "emap-flow-comment-item" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("label", [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "4px" } },
                            [_vm._v(_vm._s(item.nodeName))]
                          ),
                          _vm._v(_vm._s(_vm.$LocalH5("suggestion")) + "："),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _vm._v(_vm._s(item.comment)),
                      ]),
                      _vm._v(" "),
                      item.elecseal && !item.pos
                        ? _c(
                            "div",
                            { staticClass: "chapter-wrap" },
                            _vm._l(item.elecsealurl, function (url, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "chapter",
                                  staticStyle: { position: "relative" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleCheckSeal(item)
                                    },
                                  },
                                },
                                [
                                  _c("img", { attrs: { src: url } }),
                                  _vm._v(" "),
                                  item._waiting
                                    ? _c("Spin", {
                                        attrs: { fix: "", size: "small" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : item.elecseal && item.pos
                        ? _c(
                            "div",
                            {
                              staticClass: "chapter-wrap",
                              class: {
                                "eseal-chapter-wrap":
                                  item.pos && _vm.signatureType == "3",
                              },
                            },
                            _vm._l(item.pos, function (pos, index) {
                              return _c("div", {
                                key: index,
                                staticClass: "elecseal-pos chapter",
                                attrs: { id: pos },
                              })
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "time" }, [
                        _c("label", [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "5px" } },
                            [_vm._v(_vm._s(item.deptName))]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v(_vm._s(item.userName))]
                          ),
                          _c("span", [_vm._v(_vm._s(item.endTime))]),
                        ]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("seal-modal", {
        ref: "sealModal",
        attrs: {
          chapterWID: _vm.chapterWID,
          loading: _vm.elecsealLoading,
          elecseal: _vm.elecseal,
          multiple: _vm.multiple,
          needElecseal: _vm.needElecseal,
          needEsignature: _vm.needEsignature,
          clip: _vm.clip,
          esignature: _vm.esignature && _vm.signatureType == "1",
          signatureType: _vm.signatureType,
        },
        on: { "on-close": _vm.closeModel, "on-confirm": _vm.onConform },
        model: {
          value: _vm.elecsealSelectModel,
          callback: function ($$v) {
            _vm.elecsealSelectModel = $$v
          },
          expression: "elecsealSelectModel",
        },
      }),
      _vm._v(" "),
      _c("second-verification", {
        on: { "on-pass": _vm.onVerifyPass },
        model: {
          value: _vm.secondVerModal,
          callback: function ($$v) {
            _vm.secondVerModal = $$v
          },
          expression: "secondVerModal",
        },
      }),
      _vm._v(" "),
      _c("check-seal", {
        attrs: { show: _vm.showCheckSeal, isSuccess: _vm.isSuccess },
        on: {
          "update:show": function ($event) {
            _vm.showCheckSeal = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }